import { jsx, jsxs } from "react/jsx-runtime";
import AntCheckbox from "antd/es/checkbox";
import Skeleton from "antd/es/skeleton/Skeleton";
import classnames from "../../utils/classnames.js";
import './ModelCheckbox.css';/* empty css                   */
const ModelCheckboxSkeleton = ({
  className,
  active = true,
  type = "primary",
  layout = "full",
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    AntCheckbox,
    {
      className: classnames(
        [
          "perxis-auto-model-checkbox",
          `perxis-auto-model-checkbox--${layout}`,
          `perxis-auto-model-checkbox--${type}`,
          "perxis-auto-model-checkbox__skeleton"
        ],
        className
      ),
      ...props,
      children: /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-model-checkbox__wrapper"), children: [
        /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-model-checkbox__image-wrapper"), children: /* @__PURE__ */ jsx(
          Skeleton.Image,
          {
            active,
            className: classnames(["perxis-auto-model-checkbox__skeleton-image", "perxis-auto-model-checkbox__image"])
          }
        ) }),
        /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-model-checkbox__content"), children: [
          /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-model-checkbox__name-wrapper"), children: [
            /* @__PURE__ */ jsx(
              Skeleton,
              {
                active,
                title: false,
                paragraph: { rows: 1, width: "30%" },
                className: classnames("perxis-auto-model-checkbox__skeleton-name")
              }
            ),
            /* @__PURE__ */ jsx(
              Skeleton,
              {
                active,
                title: false,
                paragraph: { rows: 1, width: "40%" },
                className: classnames("perxis-auto-model-checkbox__skeleton-description")
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            Skeleton,
            {
              active,
              title: false,
              paragraph: { rows: 1, width: "40%" },
              className: classnames("perxis-auto-model-checkbox__skeleton-price")
            }
          )
        ] })
      ] })
    }
  );
};
export {
  ModelCheckboxSkeleton as default
};
//# sourceMappingURL=ModelCheckboxSkeleton.js.map
